import { DirectionRound } from "./direction";

async function XML2JSON(e) {
  const temperature = { time: [], values: [], name: "Температура (°C)", type: "temperature" };
  const pressure = { time: [], values: [], name: "Давление (мм рт. ст)", type: "pressure" };
  const humidity = { time: [], values: [], name: "Влажность (%)", type: "humidity" };
  const winddirect = { time: [], values: [], name: "Преобладающее направление ветра", type: "winddirect" };
  const winddirectcard = { time: [], values: [], name: "Направление ветра (Карточка)", type: "winddirectcard" };
  const windspeed = { time: [], values: { s: [], r: [], byday: [] }, name: "Скорость ветра (м/с)", type: "windspeed" };
  const r = e.text().then((e) => {
    const dom = new DOMParser();
    const xml = dom.parseFromString(e, "text/xml");
    const aggvalues = xml.getElementsByTagName("aggvalue");
    let dayBegin = "";
    let dayBeginCalm = "";
    let count = 0;
    let countCalm = 0;
    aggvalues.forEach((element) => {
      const indicator = element.getAttribute("indicator");
      const time = element.getAttribute("time").substring(0, element.getAttribute("time").length - 3);
      const value = Number(element.getElementsByTagName("avg")[0].innerHTML).toFixed(2);
      switch (indicator) {
        case "99":
          pressure.time.push(time);
          pressure.values.push(value);
          break;
        case "100":
          humidity.time.push(time);
          humidity.values.push(value);
          break;
        case "101":
          if (time.split(" ")[0] != dayBegin) {
            dayBegin = time.split(" ")[0];
            winddirect.values.push([]);
            winddirect.time.push(time);
            count++;
          }
          winddirect.values[count - 1].push(DirectionRound(value));
          if (time.split(" ")[1] == "01:00" || time.split(" ")[1] == "13:00" || time.split(" ")[1] == "19:00") {
            winddirectcard.time.push(time);
            winddirectcard.values.push(Number(DirectionRound(value)));
          }
          break;
        case "102":
          windspeed.time.push(time);
          windspeed.values.s.push(value);

          if (time.split(" ")[0] != dayBeginCalm) {
            dayBeginCalm = time.split(" ")[0];
            windspeed.values.byday.push([]);
            countCalm++;
          }

          windspeed.values.byday[countCalm - 1].push(value);

          break;
        case "103":
          temperature.time.push(time);
          temperature.values.push(value);
          break;
        case "369":
          windspeed.values.r.push(value);
          break;
        default:
          console.log("Нет таких значений");
      }
    });
    return [temperature, pressure, humidity, windspeed, winddirectcard, winddirect];
  });
  return r;
}

/* Преобразование текстовых данных */
async function XML2TextForecast(e) {
  const ugms = [];
  const russia = [];
  const r = e.text().then((e) => {
    const dom = new DOMParser();
    const xml = dom.parseFromString(e, "text/xml");
    const values = xml.getElementsByTagName("value");
    values.forEach((element) => {
      const time = element.getAttribute("time");
      const value = element.innerHTML;
      if (time.split(" ")[1] == "12:01:00") {
        ugms.push({
          time: time.split(" ")[0],
          value: value,
        });
      }
      if (time.split(" ")[1] == "12:02:00") {
        russia.push({
          time: time.split(" ")[0],
          value: value,
        });
      }
    });
    return { ugms, russia };
  });
  return r;
}

export { XML2JSON, XML2TextForecast };
